export default "https://cdn-static.gokick.com/assets/9175df2ab050434674d4a27e4dae3ab0ebb22d80/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";